var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.678 18.057C4.683 6.003 16.892-1.333 28.947 1.673c12.05 3.005 19.386 15.214 16.38 27.267-3.005 12.055-15.213 19.392-27.265 16.387C6.008 42.322-1.327 30.11 1.678 18.057Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.174 21.606 24 15.78l5.83 5.83 3.39-3.39L24 9l-9.215 9.216 3.39 3.39ZM9.001 24l3.39-3.39L15.78 24l-3.39 3.39L9 24Zm9.173 2.395L24 32.219l5.83-5.828 3.391 3.388-.002.002L24 39l-9.216-9.216-.005-.005 3.395-3.385ZM32.221 24l3.39-3.39 3.39 3.39-3.39 3.39-3.39-3.39Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.438 23.998h.002L24 20.558l-2.542 2.543-.292.292-.603.602-.005.005.005.005L24 27.442l3.44-3.44.002-.002-.004-.002Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg56);
export default __webpack_public_path__ + "static/media/56.7c381f0d07b2c852b6d48d60712f22b8.svg";
export { ForwardRef as ReactComponent };